import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type State = Partial<Record<string, boolean>>;

export const toolbarVisibilitySlice = createSlice({
    name: "toolbarVisibility",
    initialState: {} as State,
    reducers: {
        configureVisibility: (state, action: PayloadAction<Record<string, boolean>>) => ({
            ...state,
            ...action.payload,
        }),
        resetToolbarVisibility: () => ({}),
    },
});

const { actions, reducer } = toolbarVisibilitySlice;
export { actions as toolbarVisibilityActions, reducer as toolbarVisibilityReducer };
